// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"789358d3","974":"5901c239"}[chunkId] + ".chunk.css";
};